import {columnsTableTenObj as columnsTable_v1,subTitlesTableTenObj as subTitlesTable_v1} from './columns_TENOBJ';
import {columnsTableTenObj as columnsTable_v2,subTitlesTableTenObj as subTitlesTable_v2} from './columns_TENOBJ_v2';
import {columnsTableTenObj as columnsTable_v3,subTitlesTableTenObj as subTitlesTable_v3} from './columns_TENOBJ_v3';

export const columnsTableTenObj = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return columnsTable_v1(año);
        case 2:
            return columnsTable_v2(año);
        case 3:
            return columnsTable_v3(año)
        default: 
            return columnsTable_v1(año);
    }
}

export const subTitlesTableTenObj = (año, idVersion) => {
    switch (idVersion) {
        case 1:
            return subTitlesTable_v1(año);
        case 2:
            return subTitlesTable_v2(año);
        case 3:
            return subTitlesTable_v2(año);
        default: 
            return subTitlesTable_v1(año);
    }
}